<template>
    <v-dialog width="75%" :fullscreen="fullscreen === undefined ? false : true" :id="`dialog_${fullscreen ? 'full' : ''}`"
        transition="dialog-bottom-transition" v-model="show">
        <v-toolbar dark class="edit-item-header">
              <v-btn icon dark @click="show = false">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        <v-row style="gap: 12px;" class="d-flex flex-row align-center" no-gutters> 
            <v-toolbar-title>{{ isExistingEntity ? `Edit ${entityName} Details` : `Add ${entityName}` }}</v-toolbar-title> 

            <!-- <div class="body-1 font-weight-bold">14</div>

            <div><v-icon style="font-size: 14px;" color="#FFC107">{{ "mdi-circle" }}</v-icon></div>

            <div class="body-1 font-weight-bold">Active</div> -->

        </v-row>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-menu v-if="ActualCurrentEntity.id !== undefined && ActualCurrentEntity.id !== 0"
                    v-model="shareButtonTouched" :close-on-content-click="false" transition="scale-transition" offset-y
                    bottom left :nudge-width="300">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn icon small v-if="shareable !== undefined" dark text @click="share" v-bind="attrs" v-on="on"> 
                        <v-icon color="primary">{{ "mdi-share-outline" }}</v-icon>
                        </v-btn>
                    </template>
                    <v-card>
                        <v-col cols="12">
                            <v-text-field  :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                || waybillStatus == 'In Progress'
                                " v-if="shareButtonTouched" oulined label="freight-forwarder email" placeholder="freight-forwarder email" color="primary"
                                hide-details v-model="email">
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" style="text-align:center;">
                            <v-btn outlined :disabled="waybillStatus == 'Completed' || userRoleId == 5
                                || waybillStatus == 'In Progress'
                                "  color="primary" :loading="shareLoading" @click="shareByEmail()">
                                Share by email
                            </v-btn>
                        </v-col>
                    </v-card>
                </v-menu>

                <v-btn icon dark textx @click="print">
                    <v-icon color="primary">{{ "mdi-file-outline" }}</v-icon>
                </v-btn>

                <v-btn icon dark textx @click="save">
                    <v-icon color="primary">{{ "mdi-content-save-outline" }}</v-icon>
                </v-btn>

            </v-toolbar-items>
        </v-toolbar>
        <v-card :loading="loading">
            <v-col cols="12" class="logo-container">
                <img src="@/assets/napcologo.png" height="40" />
            </v-col>
            <v-card-title class="primary--text pr-4">
                <!-- {{ isExistingEntity ? `Edit ${entityName} Details` : `Add ${entityName}` }} -->
                <v-spacer />
                <!-- <v-btn icon color="grey" text @click="show = false" :disabled="loading"><v-icon>close</v-icon></v-btn> -->
            </v-card-title>
            <v-card-text class="pt-3" v-if="localizable_fields !== undefined && localizable_fields.length > 0">
                <!-- Localizable Fields -->
                <!-- <v-tabs style="margin-bottom:20px;">
                    <v-tab v-for="lang in entities['language']" :key="lang.code" @click="setLanguage(lang)">
                        {{ lang.description }}
                    </v-tab>
                </v-tabs> -->
                <div v-for="(field, index) in localizable_fields" :key="index + 'locfield'">
                    <!-- Hack for current localization to auto refresh, set showField to false, then true -->
                    <v-text-field v-if="field.type === 'textfield' && showField === true"
                        v-model="CurrentLocalization[field.value]" :placeholder="field.text" :label="field.text" outlined>
                    </v-text-field>
                </div>
                <!-- <v-divider></v-divider> -->
            </v-card-text>

            <v-card-text class="pt-3">
                <v-form ref="form" @submit.prevent>
                    <!-- <v-text-field  :rules="rules.field" color="green" outlined dense label="Name" append-icon="mdi-account" v-model="data.name"/> -->
                    <!-- <v-text-field :rules="rules.field" color="green" outlined dense label="Description" append-icon="mdi-account" v-model="data.description"/> -->
                    <div v-for="(field,index) in entity_fields" :key="index+'field'">
                        <div v-if="((user !== undefined && (user.userRoleId == 1 ||  user.userRoleId == 5)) || field.hide_client === undefined || field.client_view_only !== undefined) && field.not_editable === undefined">
                            <v-text-field v-if="(field.type === 'textfield') && field.hide_in_edit===undefined"
                                          v-model="current_entity[entityName][field.value]"
                                          :value="current_entity[entityName][field.value]"
                                          :placeholder="field.text"
                                          :label="field.text"
                                          outlined
                                          :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress'
                "></v-text-field>
                            <v-radio-group v-model="ActualCurrentEntity[field.value]" v-if="field.type==='radio'" :label="field.text">
                                <v-radio :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress'
                "
                                         v-for="(option,oIndex) in field.options" :key="option.text + `${oIndex}`"
                                         :label="option.text"
                                         color="primary"
                                         :value="option.value"></v-radio>
                            </v-radio-group>
                            <v-select :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress' "
                                      v-if="field.type === 'select'"
                                      v-model="ActualCurrentEntity[field.value]"
                                      :items="field.options"
                                      attach
                                      chips
                                      :label="field.text"></v-select>
                            <v-checkbox :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress'
                "
                                        v-if="field.type === 'checkbox'"
                                        v-model="ActualCurrentEntity[field.value]"
                                        :label="field.text"
                                        color="success"
                                        :value="ActualCurrentEntity[field.value]"
                                        hide-details></v-checkbox>
                            <div v-if="field.type === 'mobile_phone'">
                                <mobile-phones :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress'
                "
                                               v-if="driver_id !== undefined || user_id !== undefined"
                                               :driver_id="driver_id !== undefined ? driver_id:undefined"
                                               :user_id="user_id !== undefined ? user_id:undefined"></mobile-phones>
                                <div v-else>
                                    <MobilePhonesStandalone :mobilePhones="standalone_phones"></MobilePhonesStandalone>
                                </div>
                            </div>
                            <div v-if="field.type === 'date'">
                                <v-menu :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress'
                "
                                        v-model="fromDateMenu"
                                        :close-on-content-click="false"
                                        :nudge-right="40"
                                        transition="scale-transition"
                                        offset-y
                                        max-width="290px"
                                        min-width="290px">
                                    <template v-slot:activator="{ on }">
                                        <v-text-field :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress'
                "
                                                      :label="field.text"
                                                      prepend-icon="event"
                                                      readonly
                                                      outlined
                                                      :value="ActualCurrentEntity[field.value]"
                                                      v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker :disabled="waybillStatus=='Completed'
                || waybillStatus=='In Progress'   ||
                (userRoleId==5 && waybillStatus!='Pending FF')
                "
                                                   locale="en-in"
                                                   v-model="ActualCurrentEntity[field.value]"></v-date-picker>
                                </v-menu>
                            </div>
                            <google-map :disabled="waybillStatus=='Completed'
                || waybillStatus=='In Progress'  ||
                (userRoleId==5 && waybillStatus!='Pending FF')
                "
                                        v-if="field.type === 'gmap'"
                                        @setGeoFence="setGeoFence"
                                        :polygons="ActualCurrentEntity.geoRegions"
                                        @setStationsList="setStationsList"
                                        :stationsList="ActualCurrentEntity.deliveryAddresses"
                                        :has_many_stations="field.many_stations"
                                        :stations_selects="StationsSelects"
                                        :has_fencing="field.has_fencing"
                                        :entity="ActualCurrentEntity"></google-map>
                            <div v-if="field.type === 'autocomplete'">
                                <!-- <v-toolbar> -->
                                <v-toolbar-title class="title mr-6 hidden-sm-and-down">{{field.text}}</v-toolbar-title>
                                <v-autocomplete :disabled="waybillStatus=='Completed'
                || waybillStatus=='In Progress' ||
                (userRoleId==5 && waybillStatus!='Pending FF')"
                                                v-model="current_entity[entityName][field.entity]"
                                                :items="search[field.entity]"
                                                :loading="loading"
                                                :search-input.sync="search_val"
                                                @click:clear="clearSearch(field.entity)"
                                                chips
                                                :color="field.chipColor"
                                                clearable
                                                hide-details
                                                hide-selected
                                                item-text="email"
                                                item-value="id"
                                                :label="field.value"
                                                outlined
                                                return-object>
                                    <template v-slot:no-data>
                                        <v-list-item>
                                            <v-list-item-title>Search for <strong>{{field.text}}</strong></v-list-item-title>
                                        </v-list-item>
                                    </template>

                                    <template v-slot:item="{ item }">
                                        <v-list-item-avatar :disabled="waybillStatus=='Completed'
                || waybillStatus=='In Progress'  ||
                (userRoleId==5 && waybillStatus!='Pending FF')
                "
                                                            color="indigo"
                                                            class="headline font-weight-light white--text">
                                            {{ item.email.charAt(0) }}
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.email"></v-list-item-title>
                                            <v-list-item-subtitle v-text="item.email"></v-list-item-subtitle>
                                        </v-list-item-content>
                                    </template>
                                </v-autocomplete>
                                <!-- </v-toolbar> -->
                            </div>

                            <div v-if="
                field.type === 'multiselect' && field.include_in_station === undefined" :class="field.class">
                                <label class="typo__label">{{field.text}}</label>
                                <multiselect :disabled="waybillStatus=='Completed'
                   || waybillStatus=='In Progress'
                   || (userRoleId==5 && field.text=='User')
                   || (userRoleId==5 && field.text=='Freight Forwarder')
                   || (userRoleId==5 && field.text=='Assign Trucks')"
                                             v-model="current_entity[entityName][field.value]"
                                             :tag-placeholder="`Add this as new ${field.entity}`"
                                             :placeholder="`Search for ${field.entity}`"
                                             :label="field.selector"
                                             :track-by="field.selector"
                                             :options="entities[field.entity]"
                                             :multiple="field.multiple"
                                             :taggable="true"
                                             :hide-selected="false"
                                             :class="generateChipStyle(field.chipColor)"
                                             style="background:none !important"
                                             @tag="addTag">
                                </multiselect>
                            </div>
                            <div v-if="field.type === 'media_gallery'">
                                <v-card class='mediacard'>
                                    <v-card-title>{{field.text}}</v-card-title>
                                    <v-card-text>
                                        <div v-if="shouldShowMedia(field.media_type)"
                                             class="img-div"
                                             :style="`background-image:url(${getMediaUrl(field.media_type)});`"></div>
                                        <v-btn color="primary" @click="openMediaGallery(field.media_type)">Edit Media</v-btn>
                                    </v-card-text>
                                </v-card>
                                <MediaGallery :disabled="waybillStatus=='Completed'
                || waybillStatus=='In Progress'  ||
                (userRoleId==5 && waybillStatus!='Pending FF')
                "
                                              v-model="modal.mediaGalleryShown[`type${field.media_type}`]"
                                              @select="selectMedia"
                                              @mediaDeleted="removeMedia"
                                              :type="field.media_type"
                                              :userId="0"
                                              :driverId="current_entity['driver'].id"
                                              :truckId="current_entity['truck'].id !== undefined ? 0 : 0"></MediaGallery>
                            </div>
                            <div v-if="field.type === 'qr_code' && showQr">
                                <!-- <v-img
                                  v-if="ActualCurrentEntity[field.media] !== undefined"
                                  :src="ActualCurrentEntity[field.media].url"
                                  height="200"
                                  contain
                                  left
                                >
                                </v-img> -->
                                <img v-if="ActualCurrentEntity[field.media] !== undefined"
                                     :src="ActualCurrentEntity[field.media].url"
                                     height="200"
                                     width="200" />
                                <v-btn :disabled="waybillStatus=='Completed' || userRoleId==5
                || waybillStatus=='In Progress'
                "
                                       v-if="(isAdmin() || isClient())"
                                       color="primary"
                                       raised
                                       class="qrCodeButton"
                                       @click="generateQrCode(0, field.media, field.media_id)">
                                    Generate QrCode
                                </v-btn>
                            </div>
                            <v-text-field v-if="field.type === 'disabled' && showField === true"
                                          v-model="ActualCurrentEntity[field.value]"
                                          :placeholder="field.text"
                                          :label="field.text"
                                          outlined
                                          disabled>
                            </v-text-field>
                            <!-- <div v-if="field.type === 'print'">
                              <v-btn color="primary" class="print-btn" @click="print()">Print</v-btn>
                            </div> -->
                        </div>
                    </div>
                </v-form>



            </v-card-text>

            

            <v-card-actions>
                <v-dialog v-if="allowDelete[entityName] && isExistingEntity" v-model="showDeleteConfirm" max-width="290">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" text :disabled="loading" @delete="showDeleteConfirm">Delete</v-btn>
                    </template>
                    <v-card>
                        <v-card-title class="headline primary--text" :disabled="waybillStatus == 'Completed'
                            || waybillStatus == 'In Progress' ||
                            (userRoleId == 5 && waybillStatus != 'Pending FF')
                            ">
                            <v-icon color="primary" class="mr-2">error</v-icon>
                            Confirmation
                        </v-card-title>
                        <v-card-text>Are you sure do you want to delete this {{ entity }}?</v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="green" text @click="showDeleteConfirm = false">No</v-btn>
                            <v-btn color="red" text @click="deleteThisUser">Yes</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-spacer />
                <span v-if="errorMessage !== ''" class="ml-4 orange--text d-flex align-center">
                    <v-icon color="orange" class="mr-2">error</v-icon>
                    {{ errorMessage }}
                </span>
                <v-spacer />
                <!-- <v-btn color="red" text @click="show = false" :disabled="loading || waybillStatus == 'Completed'
                    || waybillStatus == 'In Progress'">Close</v-btn>
                <v-btn color="green" text @click="save" :loading="postLoading" :disabled="loading || waybillStatus == 'Completed'
                    || waybillStatus == 'In Progress'">Save</v-btn> -->
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import GoogleMap from '@/components/GoogleMap'
import MobilePhones from '../views/MobilePhones'
import MobilePhonesStandalone from './MobilePhonesStandalone'
import Multiselect from 'vue-multiselect'
import MediaGallery from './common/MediaGallery'
import Utils from '../mixins/utils'
import ShareByEmail from '../mixins/shareByEmail'

export default {
    data() {
        return {
            userRoleId: localStorage.getItem("UserRoleId"),
            errorMessage: '',
            enableValidation: false,
            showDeleteConfirm: false,
            rules: {
                field: [
                    v => !!v || 'This Field is Required',
                ]
            },
            lang_code: 'en',
            showField: true, //hack to reload the localizable field,
            showAddStandalonePhone: false,
            standalone_phones: [],
            fromDateMenu: false,
            minDate: "1900-01-01",
            search_val: null,
            waybillStatus: localStorage.getItem("SelectedwaybillStatus"),
            selectedMulti: [],
            modal: {
                mediaGalleryShown: {
                    type1: false,
                    type2: false,
                    type3: false,
                    type4: false,
                    type5: false,
                    type6: false,
                    type7: false,
                    type8: false
                },
                qrCodeGalleryShown: false
            },
            showQr: true,
            postLoading: false,
            shareButtonTouched: false,
            email: "",
            shareLoading: false
        }
    },
    mixins: [Utils, ShareByEmail],
    components: { GoogleMap, MobilePhones, MobilePhonesStandalone, Multiselect, MediaGallery },
    computed: {
        show: {
            get() {
                return this.isShown;
            },
            set(value) {
                this.standalone_phones = [];
                this.$emit('changed', value);
            }
        },
        isExistingEntity() {
            return this.current_entity[this.entityName] != undefined && this.current_entity[this.entityName].id
        },
        ...mapState('entities', ['loading', 'current_entity', 'entities', 'search', 'selected_search_entity']),
        ...mapState('users', ['loggedIn', 'user']),
        ...mapGetters('entities', ['allowDelete']),
        ActualCurrentEntity: {
            get() {
                return this.current_entity[this.entityName];
            },
            set(value) {
                this.current_entity[this.entityName] = value;
            }
        },
        Languages() {
            return this.entities['language'];
        },
        CurrentLanguage() {
            for (var i = 0; i < this.Languages.length; ++i) {
                var lang = this.Languages[i];
                if (lang.code === this.lang_code) return lang;
            }
            return null;
        },
        CurrentLocalization() {
            if (this.ActualCurrentEntity.localizations === undefined || !Array.isArray(this.ActualCurrentEntity.localizations)) {
                this.ActualCurrentEntity.localizations = [];
            }

            var loc = null;
            var loc_found = false;
            for (var i = 0; i < this.ActualCurrentEntity.localizations.length; ++i) {
                var l = this.ActualCurrentEntity.localizations[i];
                if (l.languageId === this.CurrentLanguage.id) loc = l;
            }
            if (loc === null) {
                loc = { languageId: this.CurrentLanguage.id };
                for (var i = 0; i < this.localizable_fields.length; ++i) {
                    loc[this.localizable_fields[i].value] = "";
                }
                this.current_entity[this.entityName].localizations.push(loc);
            }
            return loc
        },
        CurrentSearchEntity(name) {
            return this.current_entity[name] !== undefined ? this.entities[name].find(x => x.id === this.current_entity[name].userId) : this.selected_search_entity[name];
        },
        StationsSelects() {
            return this.entity_fields.filter(h => h.type === 'multiselect' && h.include_in_station);
        }
    },
    props: ['fullscreen', 'isShown', 'entityName', 'coordinate', 'entity_fields', 'shareable',
        'localizable_fields', 'user_id', 'driver_id'], //the data we're editing might belong to a user or driver
    methods: {
        ...mapActions('entities', ['saveEntity', 'deleteEntity', 'searchEntities']),
        ...mapActions('users', ['isAdmin'], ['isClient']),
        save() {
            if (this.$refs.form.validate()) {
                this.postLoading = true;
                this.errorMessage = '';
                var post_object = { ...this.ActualCurrentEntity };
                console.log(post_object);
                post_object.entity_name = this.entityName;
                if (this.standalone_phones.length > 0) post_object.phones = this.standalone_phones;
                if (this.selected_search_entity['user'] !== undefined) {
                    post_object.userId = this.selected_search_entity['user'].id;
                }
                if (post_object.packages !== undefined) {
                    post_object.packageIds = post_object.packages.map(p => p.id);
                    post_object.packages = null;
                    post_object.packageWayBills = null;
                }
                if (post_object.drivers !== undefined) {
                    post_object.driverIds = post_object.drivers.map(d => d.id);
                    post_object.drivers = null;
                    post_object.driverWayBills = null;
                }
                if (post_object.trucks !== undefined) {
                    post_object.truckIds = post_object.trucks.map(t => t.id);
                    post_object.trucks = null;
                    post_object.truckWayBills = null;
                }
                if (post_object.user !== undefined) {
                    post_object.userId = post_object.user.id;
                    post_object.user = null;
                }
                if (post_object.qrCodeMedia !== undefined) {
                    if (post_object.qrCodeMedia.id !== undefined) {
                        post_object.qrCodeMediaId = post_object.qrCodeMedia.id;
                        post_object.qrCodeMedia = null;
                    }
                }
                if (this.user_id !== undefined) post_object.userId = this.user_id;
                if (this.selected_search_entity['driver'] !== undefined) post_object.driverId = this.selected_search_entity['driver'].id;
                if (this.driver_id !== undefined) post_object.driverId = this.driverId;

                post_object.isActive = true;
                if (this.waybillStatus == "Pending FF" && this.userRoleId == 5) { post_object.assignToFF = true }
                if (this.waybillStatus == "Active" && this.userRoleId == 5) { post_object.assignToFF = false }

                this.saveEntity(post_object).then(response => {
                    this.show = false;
                    this.postLoading = false;
                    this.$emit('entity_posted');
                }).catch(message => {
                    this.errorMessage = message;
                    this.$swal(message);
                    this.postLoading = false;
                })
            }
            this.enableValidation = true;
        },
        deleteEntity() {
            this.showDeleteConfirm = false;
            this.deleteEntity(this.current_entity[this.entityName], this.entityName).then(message => {
                this.show = false;
            }).catch(message => {
                this.errorMessage = message;
            })
        },
        setLanguage(lang) {
            this.showField = false;
            this.lang_code = lang.code;
            setTimeout(h => { this.showField = true }, 100);
        },
        clearSearch(entity) {
            this.search[entity] = [];
        },
        getSearchItems() {
            var items = this.search['user'];
            return items;
        },
        fetchEntriesDebounced() {
            clearTimeout(this._searchTimerId);
            this._searchTimerId = setTimeout(() => {
                this.fetchEntries()
            }, 500) /* 500ms throttle */
        },
        onSelect(option, id) {
            console.log(option, id);
        },
        addTag(newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }
            this.options.push(tag);
            this.value.push(tag);
        },
        selectMedia(item) {
            if (item.typeId === 5) {
                this.ActualCurrentEntity.qrCodeMediaId = item.id;
                this.ActualCurrentEntity.qrCodeMedia = item;
                this.ActualCurrentEntity.qrCode = item.name;
            }
            else {
                if (this.ActualCurrentEntity.medias == null) this.ActualCurrentEntity.medias = []
                //find first an item with the same type and replace it
                var mediaIndex = this.ActualCurrentEntity.medias.findIndex(m => m.typeId == item.typeId);
                if (mediaIndex === undefined || mediaIndex === -1) {
                    this.ActualCurrentEntity.medias.push(item);
                }
                else {
                    this.ActualCurrentEntity.medias[mediaIndex] = item;
                }
            }
        },
        removeMedia(item) {
            var index = this.ActualCurrentEntity.medias.indexOf(m => m.id === item.id);
            if (index !== undefined && index !== null) {
                this.ActualCurrentEntity.medias.splice(index, 1);
            }
        },
        getMediaUrl(type) {
            if (this.ActualCurrentEntity.medias !== null && Array.isArray(this.ActualCurrentEntity.medias)) {
                var media = this.ActualCurrentEntity.medias.find(obj => obj.typeId === type);
                return (media !== undefined && media !== null) ? media.url : "";
            }

            return null
        },
        shouldShowMedia(type) {
            if (this.ActualCurrentEntity.medias !== null && Array.isArray(this.ActualCurrentEntity.medias)) {
                var media = this.ActualCurrentEntity.medias.filter(obj => obj.typeId === type);
                return (media !== undefined && media !== null) ? true : false;
            }
        }
        ,
        openMediaGallery(media_type) {
            this.modal.mediaGalleryShown[`type${media_type}`] = true;
        },
        setGeoFence(fence) {
            this.ActualCurrentEntity.geoRegions = fence;
        },
        setStationsList(stationsList) {
            this.ActualCurrentEntity.deliveryAddresses = stationsList;
        },
        generateChipStyle(color) {
            var styleDef = `.${color} .multiselect__tag{background:${color} !important;}`;
            let style = document.createElement('style');
            style.type = 'text/css';
            style.innerHTML = styleDef;
            document.head.appendChild(style);
            return color;
        },
        generateQrCode(id, selectorValue, selectorId) {
            axios({
                method: "GET",
                url: `${process.env.VUE_APP_baseURL}media/generateQr?id=${id}`
            }).then(response => {
                var qrMedia = response.data.data.value;
                this.ActualCurrentEntity[selectorValue] = qrMedia;
                this.ActualCurrentEntity[selectorId] = qrMedia.id;
                this.ActualCurrentEntity.qrCode = qrMedia.name;
                this.forceReloadQr();
            }).catch(error => {
                console.log(`ERRORRRRRRRRR ${error}`);
            })
        },
        forceReloadQr() {
            this.showQr = false;
            setTimeout(() => { this.showQr = true }, 150);
        },
        print() {
            // Get HTML to print from element
            window.print();
            // const elements = document.getElementsByClassName('v-dialog__content--active')
            // console.log(elements)
            // if(elements.length > 0) {
            //   const html = elements[0]
            //   const prtHtml = html.innerHTML;

            //   // Get all stylesheets HTML
            //   let stylesHtml = '';
            //   for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            //     stylesHtml += node.outerHTML;
            //   }

            //   // Open the print window
            //   const WinPrint = window.open('', '', 'toolbar=0,scrollbars=0,status=0');

            //   WinPrint.document.write(`<!DOCTYPE html>
            //   <html>
            //     <head>
            //       ${stylesHtml}
            //     </head>
            //     <body>
            //       ${prtHtml}
            //     </body>
            //   </html>`);

            //   WinPrint.document.close();
            //   WinPrint.focus();
            //   WinPrint.print();
            //   WinPrint.close();
            // }
        },
        share() {
            this.shareButtonTouched = !this.shareButtonTouched;
            // const elements = document.getElementsByClassName('v-dialog__content--active')
            // console.log(elements)
            // if(elements.length > 0) {
            //   const html = elements[0]
            //   const prtHtml = html.innerHTML;

            //   // Get all stylesheets HTML
            //   let stylesHtml = '';
            //   for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            //     stylesHtml += node.outerHTML;
            //   }

            //   var emailBody = (`<!DOCTYPE html>
            //   <html>
            //     <head>
            //       ${stylesHtml}
            //     </head>
            //     <body>
            //       ${prtHtml}
            //     </body>
            //   </html>`);

            //   var subject = this.ActualCurrentEntity.identifier;
            //   document.location = "mailto:"+"?subject="+subject+"&body="+emailBody;
            // }
        },
        shareByEmail() {
            this.shareLoading = true;
            var url = `${this.entityName}/shareByEmail`;
            var emailObject = {
                entityId: this.ActualCurrentEntity.id,
                email: this.email
            }
            this.sendEmailEntity(emailObject, url);
        }
    },
    model: {
        prop: 'isShown',
        event: 'changed'
    },
    watch: {
        show(newValue) {
            if (newValue) {
                this.data = Object.assign({}, this.user);
                if (this.$refs.form != undefined)
                    this.$refs.form.resetValidation();
                this.errorMessage = '';
                this.enableValidation = false;
            }
            else {
                this.ActualCurrentEntity = {};
                this.$emit('editItemHidden');
            }
        },
        data: {
            deep: true,
            handler() {
                if (this.enableValidation)
                    this.$refs.form.validate();
            }
        },
        search_val(val) {
            if (this.search['user'] !== undefined && this.search['user'].length > 0) return;
            if (val !== undefined && val !== null) {
                //search for the user and populate the users
                var searchPayLoad = {
                    entity_name: 'user',
                    query: val,
                    fromPage: -1,
                    toPage: -1,
                    count: -1
                }
                this.searchEntities(searchPayLoad);
            }
        },
        search_ff_val(val) {
            if (this.search['ff'] !== undefined && this.search['ff'].length > 0) return;
            if (val !== undefined && val !== null) {
                //search for the user and populate the users
                var searchPayLoad = {
                    entity_name: 'ff',
                    query: val,
                    fromPage: -1,
                    toPage: -1,
                    count: -1
                }
                this.searchEntities(searchPayLoad);
            }
        }
    },
    mounted() {
        if (this.localizable_fields !== undefined && this.localizable_fields.length > 0) {
            //should check if the current entity has a localizations array, else add one
            if (this.ActualCurrentEntity.localizations === undefined || !Array.isArray(this.ActualCurrentEntity.localizations)) {
                this.ActualCurrentEntity.localizations = [];

                //load the array with empty localiable fields for each language
                for (var i = 0; i < this.Languages.length; ++i) {
                    var loc = {};
                    loc.languageId = this.Languages[i].id;
                    for (var j = 0; j < this.localizable_fields.length; ++j) {
                        var field = this.localizable_fields[j];
                        loc[field.value] = "";
                    }
                    this.ActualCurrentEntity.localizations.push(loc);
                }
            }
        }
        localStorage.setItem("SelectedwaybillStatus", "");
    }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.img-div {
    background-size: contain;
    margin-bottom: 15px;
    height: 100px;
}

.logo-container {
    text-align: center;
}

@media print {
    header {
        display: none;
    }

    .invoiceMedia {
        display: none;
    }

    .qrCodeButton {
        display: none;
    }
}

.div-parent {
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.38);
    border-radius: 4px;
    min-width: 299px;
    max-width: 300px;
}

.qr-label {
    background-color: white;
    margin-top: -21px;
    display: flex;
    max-width: fit-content;
    font-weight: 500;
    font-size: 12px;
    color: #00000050;
}



</style>